import type { FormErrors, RegisterFormData, RegisterState } from './types';

// 从localStorage读取保存的表单数据
const loadFromLocalStorage = (): Partial<RegisterFormData> => {
  try {
    const savedData = localStorage.getItem('registerFormData');
    return savedData ? JSON.parse(savedData) : {};
  } catch (error) {
    console.error('读取localStorage失败:', error);
    return {};
  }
};

// 保存表单数据到localStorage
export const saveToLocalStorage = (data: RegisterFormData) => {
  try {
    // 密码与验证码不落盘
    const { password: _p, confirmPassword: _c, emailCode: _e, smsCode: _s, ...safeData } = data;
    localStorage.setItem('registerFormData', JSON.stringify(safeData));
  } catch (error) {
    console.error('保存localStorage失败:', error);
  }
};

// 初始状态
export const initialFormData: RegisterFormData = {
  fullName: '',

  phone: '',
  backupPhone: '',
  idCard: '',
  username: '',
  password: '',
  confirmPassword: '',
  email: '',
  emailCode: '',
  smsCode: '',
  ...loadFromLocalStorage()
};

export const initialErrors: FormErrors = {
  fullName: '',

  phone: '',
  backupPhone: '',
  idCard: '',
  username: '',
  password: '',
  confirmPassword: '',
  email: '',
  emailCode: '',
  smsCode: ''
};

export const initialState: RegisterState = {
  currentStep: 1,
  formData: { ...initialFormData },
  errors: { ...initialErrors },

  agreed: false,
  showPassword: false,
  showConfirmPassword: false,
  registerCountdown: 30,
  hasReadToBottom: false,
  usernameStatus: 'idle',
  emailStatus: 'idle',
  phoneStatus: 'idle',
  backupPhoneStatus: 'idle',
  idCardStatus: 'idle',
  passwordStrength: 0,
  emailCodeCountdown: 0,
  emailCodeSending: false,
  emailCodeSentTo: '',
  smsCodeCountdown: 0,
  smsCodeSending: false,
  identityVerification: {
    isLoading: false,
    isVerified: false,
    error: null
  },
  systemCheckLoading: false,
  systemCheckResult: null,

  registerSuccessData: null,
  showManualApplication: false,
  manualApplicationReason: '',
  manualApplicationPhoto: null,
  showIdentityMerge: false,
  selectedPrimaryIdentity: null,
  showCustomerBinding: false,

  showMismatchResolution: false
};